__turbopack_context__.v({
  "bgSoftBlue": "ContactCards-module__fc6PwW__bgSoftBlue",
  "cardBox": "ContactCards-module__fc6PwW__cardBox",
  "footer": "ContactCards-module__fc6PwW__footer",
  "primaryGrad": "ContactCards-module__fc6PwW__primaryGrad",
  "text": "ContactCards-module__fc6PwW__text",
  "title": "ContactCards-module__fc6PwW__title",
});
